import * as React from 'react';
import {Viewport} from './Viewport';
import {getSurfaceBox, useOverlay} from './OverlayContext';

type Props = {
  children: React.ReactNode;
};

export const OverlayViewport = ({children}: Props) => {
  const context = useOverlay();
  const box = getSurfaceBox(context);

  return <Viewport box={box}>{children}</Viewport>;
};

OverlayViewport.displayName = 'OverlayViewport';
